import Section from './Section';

export default Section;



// WEBPACK FOOTER //
// ./src/Section/index.js